import React from 'react';

const AddGameFAQData = [
  {
    type: 'video',
    question: "See Video Demos",
    videos: [
      { title: "Creating a Post", youtubeId: "kUz-paX3uck" }, // Replace with actual video IDs  
      { title: "Sharing a Puzzle", youtubeId: "ZPwcS5czS3o" }, // Replace with actual video IDs
    ]
  },
  {
    question: "How do I start creating content?",
    answer: [
      <>1. Make moves or set a custom position <i className="fa-solid fa-chess-knight"></i> <i className="fa-solid fa-chess-board"></i></>,
      <>2.  Add a caption & share to ChessThread <i className="fa-solid fa-paper-plane"></i></>,
      <><br /></>,

      <>Share any game, puzzle, or lesson—from your own play, the pros, or history.</>
    ]
  },
  {
    question: "How do I set a custom position?",
    answer: [
      <>1. Create a puzzle <i className="fa-solid fa-puzzle-piece"></i>, or tap the <i className="fa-solid fa-chess-board"></i></>,
      <>2. Set the custom position or paste an FEN</>,
      <>3. Load position then create your moves</>
    ]
  },
  {
    question: "How do I upload a PGN file?",
    answer: [
      <>1. Click the 'Upload PGN' button <i className="fa-solid fa-file-import"></i> </>,
      <>2. Paste a raw PGN e.g. 1. e4 e5 2. Nf3 ...</>,
    ]
  },
  {
    question: "How do I create variations?",
    answer: [
      "Branching off from any main line move will create a variation.",
    ]
  },
  {
    question: "How do I add annotations and diagrams?",
    answer: [
      <>1. Click on the customize tab <i className="fa-solid fa-font"></i></>,
      <>2. Select annotation, arrow, or square</>,
      <>3. Customize any move, one at a time</>
    ]
  },
  {
    question: "How do I draw arrows and highlight squares?",
    answer: [
      <><i className="fa-solid fa-square"></i> - Tap any square. Twice to remove.</>,
      <><i className="fa-solid fa-arrow-up"></i> - Tap Start & End square. Clear to remove.</>,
    ]
  },
  {
    question: "What are the additional controls?",
    answer: [
      <><i className="fa-solid fa-trash"></i> - Delete & start over</>,
      <><i className="fa-solid fa-retweet"></i> - Flip board POV</>,
      <><i className="fa-solid fa-chess-board"></i> - Customize start position</>,
      <><i className="fa-solid fa-scissors"></i> - Undo move / trim line</>,

    ]
  },
  {
    question: "How do I share my content?",
    answer: [
      <>1. Add moves for game / puzzle / lesson</>,
      <>2. Caption & Share <i className="fa-solid fa-paper-plane"></i></>,
      <>3. Tap 'Submit ChessThread'</>,
      <><br /></>,
      <>Your content will be published to the community feed for playback & analysis</>,
      <><br /></>,
      <>Hollywood .MP4 Video Export coming soon! </>,
    ]
  },
  {
    question: "What's the difference between games, puzzles, and lessons?",
    answer: [
      "- Games show complete or partial chess games",
      "- Puzzles have one main solution to find",
      "- Lessons are educational content explaining chess concepts",
      "- Choose the appropriate tag when sharing your content"
    ]
  },
  {
    question: "Can I create private content?",
    answer: [
      "- Currently, all shared content is public and visible in the community feed",
      "- Private posting features are planned for future updates",
      "- You can analyze privately by simply not clicking 'Caption & Share'"
    ]
  }
];

export default AddGameFAQData;